import React, { useEffect, useRef } from "react";

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  danger = false,
  onConfirm,
  onCancel,
}) => {
  const cancelButtonRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const previousActiveElement = document.activeElement;
    document.body.classList.add("modal-open");
    cancelButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        onCancel?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.classList.remove("modal-open");
      previousActiveElement?.focus?.();
    };
  }, [onCancel, open]);

  if (!open) {
    return null;
  }

  const titleId = "confirm-dialog-title";
  const messageId = "confirm-dialog-message";

  return (
    <div className="confirm-dialog-overlay" role="presentation">
      <section
        className={`confirm-dialog-card${danger ? " confirm-dialog-danger" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={messageId}
      >
        <div className="confirm-dialog-icon" aria-hidden="true">
          <i className={`bi ${danger ? "bi-exclamation-triangle" : "bi-question-circle"}`}></i>
        </div>
        <div className="confirm-dialog-content">
          <h2 id={titleId}>{title}</h2>
          <p id={messageId}>{message}</p>
        </div>
        <div className="confirm-dialog-actions">
          <button
            ref={cancelButtonRef}
            type="button"
            className="btn btn-outline-secondary"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`btn ${danger ? "btn-danger" : "btn-primary"}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
};

export default ConfirmDialog;
